import { PropsWithChildren, useState } from "react"
import { makeStyles } from "tss-react/mui"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material"

const INDENT_SIZE = ".5rem"

const useStyles = makeStyles()((theme) => ({
    accordion: {
        padding: `${INDENT_SIZE} 0`,
        borderRadius: "0.75rem",
        boxShadow: "none",
        flex: "none",
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,

        "&:first-of-type, &:last-of-type": {
            borderRadius: "0.75rem",
        },
        "&.Mui-expanded": {
            margin: 0,
        },
        "&:before": {
            display: "none",
        },
    },
    accordionSummary: {
        minHeight: "auto",
        "&.Mui-expanded": {
            minHeight: "auto",
        },
        "& .MuiAccordionSummary-content": {
            margin: 0,
            "&.Mui-expanded": {
                margin: 0,
            },
        },
    },

    accordionDetails: {
        textAlign: "left",
        padding: "1rem 1rem 0",
        marginTop: INDENT_SIZE,
        borderTop: `1px solid ${theme.palette.tailwind.slate[200]}`,
    },
}))

type ExtraServicesAccordionProps = Readonly<
    PropsWithChildren<{
        title: string
        defaultExpanded?: boolean
    }>
>

export function ExtraServicesAccordion({ title, defaultExpanded = false, children }: ExtraServicesAccordionProps) {
    const { classes } = useStyles()
    const [expanded, setExpanded] = useState(defaultExpanded)

    const handleChange = () => {
        setExpanded((prev) => !prev)
    }

    return (
        <Accordion expanded={expanded} onChange={handleChange} className={classes.accordion}>
            <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">{title}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>{children}</AccordionDetails>
        </Accordion>
    )
}
